import fr from '../lang/fr.json'
import de from '../lang/de.json'
import ca from '../lang/ca.json'
import es from '../lang/es.json'
import it from '../lang/it.json'
import pl from '../lang/pl.json'
import pt from '../lang/pt.json'
import tr from '../lang/tr.json'

export default defineI18nConfig(() => ({
  legacy: false,
  locale: 'en',
  fallbackLocale: 'en',
  messages: {
    fr,
    de,
    ca,
    es,
    it,
    pl,
    pt,
    tr,
  },
}))
